export const workoutScheduleEventCmsHelperText =
  "Settings for scheduling Workouts to be featured in Coa's native mobile app.";
